import { Component, Input } from '@angular/core';


/**
 * Lightweight, structural mirror of the portalServices `IDashboard` interface.
 * Declared locally so the shared library does not need a hard dependency on
 * `portalServices`. Consumers may pass any object that is assignable to this
 * shape (the `IDashboard` from portalServices is structurally compatible).
 */
export interface DashboardViewData
{
    TopPanel?: any[];
    BottomPanel?: any[];
}

/**
 * Shared dashboard view used by both the admin client and the employee portal.
 *
 * Renders the top "alert" panels and the bottom card panels (with embedded
 * <app-chart-canvas> charts). All Chart.js handling lives in the
 * ChartCanvasComponent so this component is purely presentational.
 *
 * Usage:
 *   <app-dashboard-view [data]="dashBoardData" [isLoader]="isLoader">
 *   </app-dashboard-view>
 */
@Component({
    selector: 'app-dashboard-view',
    templateUrl: './dashboard-view.component.html',
    styleUrls: ['./dashboard-view.component.scss']
})
export class DashboardViewComponent
{
    @Input() data: DashboardViewData = { TopPanel: [], BottomPanel: [] };
    @Input() isLoader: boolean = false;

    /**
     * Splits a pipe/comma separated value into chip-friendly tokens.
     */
    public getSplitValue(value: any): string[]
    {
        if (value === null || value === undefined) { return []; }
        return String(value)
            .split(/[,|]/)
            .map(v => v.trim())
            .filter(v => v.length > 0);
    }
}

